"use client";

import { useRouter } from "next/navigation";
import { useActionState, useEffect, useState } from "react";
import SubmitButton from "~/components/common/SubmitButton";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { toast } from "~/hooks/use-toast";
import { type VideoSubmissionState } from "~/types/generic-action";

import { useQueueActions } from "../../queue-context";
import { initializeVideoAction } from "../actions";

export default function NewVideoForm() {
  const [state, formAction] = useActionState<VideoSubmissionState, FormData>(
    initializeVideoAction,
    {},
  );
  const router = useRouter();
  const { enqueue } = useQueueActions();

  useEffect(() => {
    const { success, taskId, publicAccessToken, videoId } = state;

    console.log(state);

    if (success === true && videoId) {
      if (taskId && publicAccessToken) {
        enqueue({
          taskIdentifier: "process-video",
          runId: taskId,
          publicAccessToken,
          metadata: { videoId: videoId.toString() },
        });
      }
      router.push(`/videos/${videoId}`);
    } else if (state.success === false) {
      toast({
        variant: "destructive",
        title: "Error",
        description: state.message,
      });
    }
  }, [state, router, enqueue]);

  const [inputValue, setInputValue] = useState("");

  return (
    <form action={formAction} className="grid gap-6">
      <div className="grid gap-2">
        <Label htmlFor="url">YouTube URL</Label>
        <Input
          id="url"
          name="url"
          className="w-full"
          placeholder="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        {state.success === false && (
          <p className="text-sm text-red-500">
            {state.message ??
              state.errors?.map((error) => error.message).join(", ") ??
              "An error has occured"}
          </p>
        )}
        {state.success && state.message && (
          <p className="text-sm text-green-500">{state.message}</p>
        )}
        <p className="text-sm text-muted-foreground">
          Grab the URL from any YouTube video and paste it here.
        </p>
      </div>
      <div>
        <SubmitButton
          pendingName="Processing..."
          name="Start"
          disabled={!inputValue.trim()}
        />
      </div>
    </form>
  );
}
